import "assets/scss/pages/home.scss";

import { Common } from "components";

type Props = {};

export const Home = (props: Props) => {
  return (
    <>
      <Common.Intro />
      <Common.Overview />
      <Common.Technology />
      <Common.Project />
      <Common.Repo />
      <Common.Activity />
    </>
  );
};
